// extracted by mini-css-extract-plugin
module.exports = {"failureList":"failureList--Lrl3P","date":"date--ozXB1","text":"text--Nsxfi","failureItem":"failureItem--OIEfh","failureIcon":"failureIcon--aOvOS"};